/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChatIdIndexRouteImport } from './routes/$chatId/index'
import { Route as ChatIdCampaignIndexRouteImport } from './routes/$chatId/campaign/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIdIndexRoute = ChatIdIndexRouteImport.update({
  id: '/$chatId/',
  path: '/$chatId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIdCampaignIndexRoute = ChatIdCampaignIndexRouteImport.update({
  id: '/$chatId/campaign/',
  path: '/$chatId/campaign/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$chatId/': typeof ChatIdIndexRoute
  '/$chatId/campaign/': typeof ChatIdCampaignIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$chatId': typeof ChatIdIndexRoute
  '/$chatId/campaign': typeof ChatIdCampaignIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$chatId/': typeof ChatIdIndexRoute
  '/$chatId/campaign/': typeof ChatIdCampaignIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$chatId/' | '/$chatId/campaign/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$chatId' | '/$chatId/campaign'
  id: '__root__' | '/' | '/$chatId/' | '/$chatId/campaign/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChatIdIndexRoute: typeof ChatIdIndexRoute
  ChatIdCampaignIndexRoute: typeof ChatIdCampaignIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$chatId/': {
      id: '/$chatId/'
      path: '/$chatId'
      fullPath: '/$chatId/'
      preLoaderRoute: typeof ChatIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$chatId/campaign/': {
      id: '/$chatId/campaign/'
      path: '/$chatId/campaign'
      fullPath: '/$chatId/campaign/'
      preLoaderRoute: typeof ChatIdCampaignIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChatIdIndexRoute: ChatIdIndexRoute,
  ChatIdCampaignIndexRoute: ChatIdCampaignIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
